import { network } from 'services/network';

export const resetClustersList = (params) => {
    return network.post('api/bo/resetClustersList', params).then((response) => response.data);
};
